(function () {
	'use strict';

	angular
		.module('wizard-future7')
		.controller('DefaultCountdownController', DefaultCountdownController)

	/** @ngInject */
	function DefaultCountdownController($interval, $state, HelperService) {
		const vm = this;

		vm.openModal = function () {
			$('#modalVideo').modal('show');
		};

		init();

		function timeLeft() {
			let endDate = vm.conferenceDate
			let today = moment();

			let distance = endDate - today;

			vm.timeLeft = {
				days: Math.floor(distance / (1000 * 60 * 60 * 24)),
				hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
				minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
				seconds: Math.floor((distance % (1000 * 60)) / 1000)
			}

			if (distance <= 0)
				$state.go("default.home");

			HelperService.stopLoading(".app-body");
		}

		function init() {
			HelperService.startLoading(".app-body", '', true);

			vm.conferenceDate = moment("2019-10-11 09:00:00");

			$interval(() => timeLeft(), 500);
		}

	}
}());